import { actions } from 'src/actions/userPin.actions'
import { extract, successState } from 'src/actions/global.actions'

const initialState: UserPinState = {
  userPin: undefined,
}

const UserPinReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case successState(actions.GET_USER_PIN):
      return { ...state, userPin: extract(payload, undefined) }
    default:
      return state
  }
}
export default UserPinReducer
